import type { UseActionResult } from '@ztechapps/common.hook'
import { useActionMutation } from '@ztechapps/common.hook'
import type { Logistic, SetLogisticCustomShippingCarrierArgs } from '@ztechapps/common.contract'
import { setLogisticCustomShippingCarrierQuery } from './graphql'

export type UseSetLogisticCustomShippingCarrierResult = UseActionResult<Logistic, SetLogisticCustomShippingCarrierArgs>

export const useSetLogisticCustomShippingCarrier = (): UseSetLogisticCustomShippingCarrierResult =>
  useActionMutation<Logistic, SetLogisticCustomShippingCarrierArgs>({ query: setLogisticCustomShippingCarrierQuery })
